<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        Competitor Keywords Comparison
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/competition/compare"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          v-if="widget.editable"
          class="btn btn_sm btn-info"
          @click="$parent.edit(widget)"
        >
          Options
        </button>
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </button>
      </div>
    </div>
    <div
      v-if="!loading"
      class="table_wrapper"
    >
      <table class="table_component">
        <thead>
          <tr>
            <td>
            &nbsp;
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
            >
              <span>{{ competitor.id == activeWebsite.id ? 'Your Website' : competitor.simpleUrl }}</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Keywords in Position 1
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.pos1"
            />
          </tr>
          <tr>
            <td>
              Keywords in Top 3
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.top3"
            />
          </tr>
          <tr>
            <td>
              Keywords on Page 1
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.page1"
            />
          </tr>
          <tr>
            <td>
              Keywords on Page 2
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.page2"
            />
          </tr>
          <tr>
            <td>
              All Keywords
            </td>
            <td
              v-for="(competitor, index) in competitors"
              :key="index"
              :style="`width: ${70 / competitors.length}%`"
              v-html="competitor.allKeywords"
            />
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-else
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {mapState} from 'vuex'
import axios from 'axios';

export default {
  props: {
    widget: {
      type: Object,
      default: null,
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      competitors: {},
    }
  },
  computed: {
    ...mapState('dashboard', ['activeWebsite', 'uuid', 'preview']),
  },
  watch: {
    'widget.competitors': {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.fetchData();
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      axios.post('/ajax/dashboard/get-widget-data', {
        type: 'competitionKeywords',
        competitor_ids: this.widget.competitors,
        uuid: this.uuid
      }).then(response => {
        this.competitors = response.data;
        this.loading = false;
      }).catch(error => {
        console.log(error);
      });
    }
  }
}
</script>

<style scoped>
small.green {
  color: #00a651;
}

small.red {
  color: #e50000;
}

small.grey {
  color: #979797;
}

tr td:not(:first-of-type) {
  text-align: center;
}

tr td:first-of-type {
  width: 30%;
}
</style>
